module.exports = __webpack_public_path__ + "media/images/about/bg01-51d57ebe2e603c3e02e9036275841047.png";